import { render } from "./TowerScore.vue?vue&type=template&id=c7435d06&scoped=true"
import script from "./TowerScore.vue?vue&type=script&lang=js"
export * from "./TowerScore.vue?vue&type=script&lang=js"

import "./TowerScore.vue?vue&type=style&index=0&id=c7435d06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7435d06"]])

export default __exports__